<template>
  <div class="faq-icon-wrapper" :class="{ 'faq-icon-wrapper-mobile': isMobile }" :style="{ bottom: isMobile ? `${bottom}rem` : `${bottom}px` }" @click="toFaqPage" >
    <img class="icon" src="/image/faq-icon.svg" alt="">
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useClientCompatibleHook } from '@/utils/hooks'

export default defineComponent({
  components: {
  },
  props: [],
  setup () {
    const { push, isMobile } = useClientCompatibleHook()
    const BASIC_BOTTOM = isMobile.value ? 5.6 : 200
    const bottom = ref(BASIC_BOTTOM)
    const toFaqPage = () => {
      push('/faq')
    }
    // const onScroll = () => {
    //   // 距离页脚140px
    //   const pageFooter = document.querySelector('.app-layout-footer .page-footer')
    //   if (pageFooter) {
    //     const top = pageFooter.getBoundingClientRect().top
    //     const wHeight = window.innerHeight || document.documentElement.clientHeight
    //     if (top < wHeight) {
    //       // 页脚进入视窗
    //       const offset = wHeight - top
    //       bottom.value = BASIC_BOTTOM + offset
    //     } else {
    //       bottom.value = BASIC_BOTTOM
    //     }
    //   }
    // }
    // onMounted(() => {
    //   window.addEventListener('scroll', onScroll)
    // })
    // onUnmounted(() => {
    //   window.removeEventListener('scroll', onScroll)
    // })
    return {
      bottom,
      toFaqPage,
      isMobile
    }
  }
})
</script>

<style scoped lang="less">
.faq-icon-wrapper {
  position: fixed;
  right: 30px;
  z-index: 999;
  width: 50px;
  height: 50px;
  background-image: linear-gradient(180deg, #F8F8F8 0%, #FFFFFF 51%, #F8F8F8 100%);
  border: 2px solid rgba(255,255,255,1);
  box-shadow: 0px 0px 11px 0px rgba(55,99,170,0.16);
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .icon {
    width: 30px;
  }
}

.faq-icon-wrapper-mobile {
  width: 4.4rem;
  height: 4.4rem;
  right: 0.4rem;
  .icon {
    width: 2.5rem;
  }
}
.rtl--container {
  .faq-icon-wrapper {
    right: auto;
    left: 30px;
  }
  .faq-icon-wrapper-mobile {
    left: 0.4rem;
  }
}
</style>
